export default __webpack_public_path__ + "/assets/gallery-02.jpg";